import * as anchor from '@project-serum/anchor';
import { WalletModalProvider } from '@solana/wallet-adapter-ant-design';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
// import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';
import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import {
  LedgerWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolflareWalletAdapter,
  SolletExtensionWalletAdapter,
  SolletWalletAdapter,
  TorusWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';
import 'antd/dist/antd.min.css';
import { useEffect, useMemo, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Mint } from './components/mint/Mint';
import { StakingProvider } from './contexts/Staking/Provider';
import Home from './pages/Home';
import Staking from './pages/Staking';
import { Styles } from './styles/styles';
import i18n from './translation';
require('@solana/wallet-adapter-ant-design/styles.css');
const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
// const rpcHost = 'https://api.metaplex.solana.com/';
// const rpcHost =
//   'https://explorer.solana.com/address/A2EjMCqhipqrYPEyrNpBNFn7fCmpU4bx2sAqctX9FNUU?cluster=devnet';

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      '5KHBLuS6oXTkDy3LnNE8SUbKAGb2LfDaYmJxza1rCJmU'!
    );

    return candyMachineId;
  } catch (e) {
    console.log('Failed to construct CandyMachineId', e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);
const txTimeoutInMilliseconds = 30000;
export const App = () => {
  const [rpcHost, setRpcHost] = useState<string>(
    localStorage.getItem('rpc') as string
  );

  useEffect(() => {
    if (localStorage.getItem('rpc')) {
      setRpcHost(localStorage.getItem('rpc') as string);
    }
  }, []);

  const connection = new anchor.web3.Connection(
    rpcHost ? rpcHost : anchor.web3.clusterApiUrl('mainnet-beta')
  );
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({ network }),
      new TorusWalletAdapter(),
      new LedgerWalletAdapter(),
      new SolletWalletAdapter({ network }),
      new SolletExtensionWalletAdapter({ network }),
    ],
    [network]
  );
  return (
    <div className='App'>
      <BrowserRouter>
        <Styles />
        <I18nextProvider i18n={i18n}>
          <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
              <WalletModalProvider>
                <Routes>
                  <Route path='/' element={<Home />} />
                  <Route
                    path='/staking'
                    element={
                      <StakingProvider connection={connection}>
                        <Staking />
                      </StakingProvider>
                    }
                  />
                  <Route
                    path='/mint'
                    element={
                      <Mint
                        candyMachineId={candyMachineId}
                        connection={connection}
                        startDate={startDateSeed}
                        txTimeout={txTimeoutInMilliseconds}
                        rpcHost={rpcHost}
                      />
                    }
                  />
                </Routes>
              </WalletModalProvider>
            </WalletProvider>
          </ConnectionProvider>
        </I18nextProvider>
      </BrowserRouter>
    </div>
  );
};
